export class Constants {
  public static APPLICATION_ID = 8;
}
